function load_grid_view(grid_view_anchor)
{
    $.get('/grid_view_test.html', function(data) {
        $(`#${grid_view_anchor}`).replaceWith(data);
    });
}

function init_switcher()
{
    var loaded_grid = false;
    var grid_view_anchor = "grid-view-anchor";

    $( ".grid_hp" ).click(function(){

        if( loaded_grid == false && $(`#${grid_view_anchor}`).length > 0 ){
            load_grid_view(grid_view_anchor);
            loaded_grid = true;
        }

        $('.list_view_default').hide();

        $( ".grid-view" ).css({ "display" : "block" });
        $( ".list-view" ).css({ "display" : "none" });

        $( ".list-style .grid_hp" ).addClass("active");
        $( ".list-style .list_hp" ).removeClass("active");

        var data = {
            'ge_action' : 'Grid View',
            'ge_category' : 'Section: Homepage',
            'ge_label' : 'Click',
            'ge_noninteraction' : false
        };
        send_ga_event(data);

        // Ask if this should be default
        if( SITE_INFO['name'] != "investigations" ){

            $('.grid_view_default .yes').click(function() {
                createCookie('grid_view_default','1','365');
                $('.grid_view_default').hide();
                var grid_data = {
                    'ge_action' : 'Grid View',
                    'ge_category' : 'Section: Homepage',
                    'ge_label' : 'Set Grid Cookie: Yes',
                    'ge_noninteraction' : false
                };
                send_ga_event(grid_data);
            });
            $('.grid_view_default .no').click(function() {
                createCookie('grid_view_default','0','365');
                $('.grid_view_default').hide();
                var grid_data = {
                    'ge_action' : 'Grid View',
                    'ge_category' : 'Section: Homepage',
                    'ge_label' : 'Set Grid Cookie: No',
                    'ge_noninteraction' : false
                };
                send_ga_event(grid_data);
            });

            if(readCookie('grid_view_default') != '1') {
                $('.grid_view_default').show();
            }
        }
    });

    $( ".list_hp" ).click(function(){

        $('.grid_view_default').hide();

        $( ".list-view" ).css({ "display" : "block" });
        $( ".grid-view" ).css({ "display" : "none" });

        $( ".list-style .list_hp" ).addClass("active");
        $( ".list-style .grid_hp" ).removeClass("active");

        var data = {
            'ge_action' : 'List View',
            'ge_category' : 'Section: Homepage',
            'ge_label' : 'Click',
            'ge_noninteraction' : false
        };
        send_ga_event(data);

        // Ask if this should be default
        if( SITE_INFO['name'] != "investigations" ){

            $('.list_view_default .yes').click(function() {
                createCookie('grid_view_default','0','365');
                $('.list_view_default').hide();
                var list_data = {
                    'ge_action' : 'List View',
                    'ge_category' : 'Section: Homepage',
                    'ge_label' : 'Set List View Cookie: Yes',
                    'ge_noninteraction' : false
                };
                send_ga_event(list_data);
            });
            $('.list_view_default .no').click(function() {
                createCookie('grid_view_default','1','365');
                $('.list_view_default').hide();
                var list_data = {
                    'ge_action' : 'List View',
                    'ge_category' : 'Section: Homepage',
                    'ge_label' : 'Set List View Cookie: No',
                    'ge_noninteraction' : false
                };
                send_ga_event(list_data);
            });
            
            if(readCookie('grid_view_default') != '0') {
                $('.list_view_default').show();
            }
        }
    });

    // Read cookie to determine if grid is default, if so, click
    if(readCookie('grid_view_default') == '1') {
        $( ".grid_hp" ).trigger('click');
    }
}

export default init_switcher;